export default __webpack_public_path__ + "static/media/OrganDataGraphic.577357e9.png";